// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.no-valves-assigned-message {
  padding: 16px 24px;
  color: #0066b2;
  font-style: italic;
  font-size: 1.1rem;
  text-align: center;
  margin: 0;
}

.valves-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.valves-header h3 {
  margin: 0;
  font-weight: 500;
}
.valves-header .add-valves-section .add-valves-button-container .add-valves-button {
  display: inline-flex;
  font-family: "GothamBold", Arial, sans-serif;
  align-items: center;
  gap: 4px;
  color: #0066b2;
}
.valves-header .add-valves-section .add-valves-button-container .add-valves-button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  order: 1;
  margin-left: 4px;
}

.mat-accordion .mat-expansion-panel-header {
  padding: 16px 24px;
}
.mat-accordion .mat-expansion-panel-body {
  padding: 16px 24px;
}

.valves-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
}
.valves-table thead th {
  background-color: #f7f7f7;
  border: 1px solid silver;
  padding: 12px;
  font-weight: 600;
  text-align: left;
}
.valves-table tbody tr:hover {
  background-color: #f8f9fa;
}
.valves-table tbody tr td {
  background-color: white;
  border: 1px solid silver;
  padding: 10px;
  vertical-align: top;
}

.notes-column {
  position: relative;
}
.notes-column .notes-content {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.notes-column .notes-content .note-container {
  flex: 1;
}
.notes-column .notes-content .note-container .orphaned-notes {
  font-style: italic;
  color: #666;
  font-size: 11px;
}
.notes-column .notes-content .edit-notes-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notes-column .notes-content .edit-notes-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.cell-content-with-add {
  display: flex;
  align-items: center;
  min-height: 24px;
  min-width: 90px;
}

.cell-content-with-edit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;
}

.add-text-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-size: 14px;
  font-family: "GothamBold", Arial, sans-serif;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.add-text-link mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
  float: none;
}
.add-text-link:hover {
  text-decoration: underline;
  font-weight: bolder;
}

.notes-add-button.inline-add {
  font-weight: 400;
}

.edit-text-link {
  color: #1976d2;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}
.edit-text-link:hover {
  background-color: rgba(13, 71, 161, 0.04);
}
.edit-text-link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  float: none;
}

.notes-edit-button.inline-add {
  margin-left: 8px;
}

.componentType {
  padding-left: 35px;
  font-weight: bold;
}
.componentType .component-cell-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.componentType .component-cell-content .component-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.componentType .component-cell-content .component-info .drag-handle {
  cursor: move;
  color: #666;
}
.componentType .component-cell-content .component-info .drag-handle mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.componentType .component-cell-content .component-info .component-text {
  font-weight: bold;
}
.componentType .component-cell-content .component-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.compare-row-new td {
  background-color: #e8f5e9 !important;
}

.compare-row-deleted td {
  background-color: #ffebee !important;
  color: #6d2a2a;
  text-decoration: line-through;
}

.valve-tag {
  color: #0066B2;
  cursor: pointer;
}
.valve-tag a {
  text-decoration: none;
  color: inherit;
}
.valve-tag a:hover {
  text-decoration: underline;
}

.valve-tag-split-button {
  display: inline-flex;
  align-items: center;
}
.valve-tag-split-button .valve-version-caret {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  margin-left: 2px;
  cursor: pointer;
  color: inherit;
}
.valve-tag-split-button .valve-version-caret mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

::ng-deep .valve-version-menu .mat-mdc-menu-item {
  height: auto;
  min-height: 48px;
  line-height: 1.3;
  padding-top: 8px;
  padding-bottom: 8px;
}
::ng-deep .valve-version-menu .valve-version-status {
  display: block;
  font-size: 13px;
  font-weight: 600;
}
::ng-deep .valve-version-menu .valve-version-name {
  display: block;
  font-size: 12px;
  opacity: 0.7;
}

.no-valves-message {
  text-align: center;
  font-style: italic;
  color: #666;
  padding: 20px;
}

.description-cell .description-display .editable-description {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 0;
  padding: 0;
  font: inherit;
  color: inherit;
  text-align: left;
}
.description-cell .description-display .editable-description:hover {
  background-color: #f0f0f0;
  padding: 2px 4px;
  border-radius: 4px;
}
.description-cell .description-display .editable-description .edit-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.6;
}
.description-cell .description-edit-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.description-cell .description-edit-container .description-input {
  min-width: 160px;
}
.description-cell .description-edit-container .description-edit-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.description-cell .description-edit-container .description-edit-actions button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.description-cell .description-edit-container .description-edit-actions button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.nps-cell .nps-display .editable-nps {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.nps-cell .nps-display .editable-nps:hover {
  background-color: #f0f0f0;
  padding: 2px 4px;
  border-radius: 4px;
}
.nps-cell .nps-display .editable-nps .edit-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.6;
}
.nps-cell .nps-edit-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.nps-cell .nps-edit-container .nps-input {
  min-width: 100px;
}
.nps-cell .nps-edit-container .nps-edit-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.nps-cell .nps-edit-container .nps-edit-actions button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nps-cell .nps-edit-container .nps-edit-actions button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.nps-cell .nps-display .editable-nps {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.nps-cell .nps-display .editable-nps:hover {
  background-color: #f0f0f0;
  padding: 2px 4px;
  border-radius: 4px;
}
.nps-cell .nps-display .editable-nps .edit-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.6;
}

.ratings-cell .ratings-display .editable-ratings {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.ratings-cell .ratings-display .editable-ratings:hover {
  background-color: #f0f0f0;
  padding: 2px 4px;
  border-radius: 4px;
}
.ratings-cell .ratings-display .editable-ratings .edit-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.6;
}
.ratings-cell .ratings-edit-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ratings-cell .ratings-edit-container .ratings-input {
  min-width: 100px;
}
.ratings-cell .ratings-edit-container .ratings-edit-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.ratings-cell .ratings-edit-container .ratings-edit-actions button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ratings-cell .ratings-edit-container .ratings-edit-actions button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.ends-cell .ends-display .editable-ends {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.ends-cell .ends-display .editable-ends:hover {
  background-color: #f0f0f0;
  padding: 2px 4px;
  border-radius: 4px;
}
.ends-cell .ends-display .editable-ends .edit-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.6;
}
.ends-cell .ends-edit-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ends-cell .ends-edit-container .ends-input {
  min-width: 100px;
}
.ends-cell .ends-edit-container .ends-edit-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.ends-cell .ends-edit-container .ends-edit-actions button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ends-cell .ends-edit-container .ends-edit-actions button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

tr td {
  background-color: white;
  border-left: 1px solid silver;
  border-right: 1px solid silver;
}

table {
  border: 1px solid silver;
}

table th {
  border: 1px solid silver;
  background-color: #f7f7f7;
}

.ellipses {
  border-bottom: 1px solid silver;
}

table tr th, table tr td {
  padding: 10px;
}

.valve-row-header {
  display: flex;
  max-height: 1%;
}

#row-header-open {
  border-top: none;
  border-right: none;
  border-bottom: 1px solid silver;
  border-left: none;
}

#row-header-closed {
  border: none;
}

.revision-col {
  white-space: nowrap;
}

.sch1rat {
  white-space: nowrap;
}

.note-container {
  display: flex;
  flex-direction: row;
  color: #0066b2;
  border-right-width: 0px;
  border-left-width: 0px;
  background-color: white;
}
.note-container .note-element {
  margin-right: 3px;
}
.note-container .note-element:hover {
  margin-right: 3px;
  cursor: pointer;
  text-decoration: underline;
  font-weight: bolder;
}

.comments-container {
  margin-top: 20px;
}

.add-valves-btn {
  margin-left: 12px;
  height: 30px;
  line-height: 28px;
  padding: 0 14px;
}

.inline-actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-left: 6px;
}

.draggable-row.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  background: white;
  opacity: 0.9;
}
.draggable-row.cdk-drag-placeholder {
  opacity: 0.3;
  background: #f5f5f5;
}
.draggable-row.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.drag-handle {
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
  color: #666;
  cursor: move;
}
.drag-handle mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  float: none;
}
.drag-handle:hover {
  color: #333;
}

.nps-cell {
  min-width: 120px;
}
.nps-cell .nps-display {
  display: flex;
  align-items: center;
  min-height: 24px;
}
.nps-cell .editable-nps {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 60px;
  color: #0066b2;
  transition: background-color 0.2s ease;
}
.nps-cell .editable-nps:hover {
  background-color: #f0f8ff;
}
.nps-cell .editable-nps:hover .edit-icon {
  opacity: 1;
}
.nps-cell .editable-nps .nps-value {
  flex: 1;
}
.nps-cell .editable-nps .nps-value:empty::before {
  content: "Add NPS";
  color: #999;
  font-style: italic;
}
.nps-cell .editable-nps .edit-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: #666;
  opacity: 0.5;
  float: none;
  cursor: pointer;
}
.nps-cell .editable-nps .edit-icon:hover {
  color: #1976d2;
}
.nps-cell .nps-readonly {
  padding: 4px 8px;
  display: inline-block;
  min-width: 60px;
  color: #333;
}

.nps-edit-container {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
.nps-edit-container .nps-input {
  width: 100px;
}
.nps-edit-container .nps-input .mat-mdc-form-field-wrapper {
  padding-bottom: 0;
}
.nps-edit-container .nps-input .mat-mdc-text-field-wrapper {
  height: 32px;
}
.nps-edit-container .nps-input input {
  font-size: 14px;
  padding: 4px 8px;
}
.nps-edit-container .nps-edit-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.nps-edit-container .nps-edit-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
}

tbody[cdkDropList] tr {
  display: table-row;
  width: 100%;
}
tbody[cdkDropList] td {
  display: table-cell;
}

.fa-trash-can {
  color: #97002e;
  margin-left: 5%;
  cursor: pointer;
}

.delete-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  border: none;
  background-color: #fff;
}

.catalog-indicator-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  border-radius: 50%;
  transition: background 0.15s;
}
.catalog-indicator-button:hover {
  background: rgba(0, 0, 0, 0.06);
}

.catalog-indicator-upgrade {
  color: #f57c00;
}

.catalog-indicator-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 14px;
  cursor: default;
}

.catalog-indicator-outdated {
  color: #f57c00;
}

.catalog-indicator-deprecated {
  color: #c62828;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
